<template>
  <form v-on:submit.prevent class="container-fluid">
    <slot></slot>
    <div class="row">
      <div :class="`${classDiv} text-right`">
        <button v-if="showBtnReset" type="button" :class="`btn btn-sm ${classBtnReset}`" @click="filterReset" ref="btnReset">
          <i class="glyphicon glyphicon-remove"></i> {{ buttonTextReset }}
        </button>
        <button type="button" :class="`btn btn-sm ${classBtnSearch} ${classLaddaButton}`" @click="filter" data-style="slide-up" ref="btnSearch">
          <i class="glyphicon glyphicon-search"></i> {{ buttonText }}
        </button>
      </div>
    </div>
    <slot name="sub-row"></slot>
  </form>
</template>

<script>
  import Ladda from 'ladda';

  export default {
    name: 'search-bar',

    components: {
      Ladda,
    },

    props: {
      search: {
        required: true,
      },
      reset: {
        required: false,
      },
      showBtnReset: {
        type: Boolean,
        default: false,
      },
      classBtnSearch: {
        type: String,
        default: 'btn-default',
      },
      classBtnReset: {
        type: String,
        default: 'btn-default',
      },
      classLaddaButton: {
        type: String,
        default: 'ladda-button',
      },
      buttonText: {
        type: String,
        default: 'Pesquisar',
      },
      buttonTextReset: {
        type: String,
        default: 'Limpar',
      },
      classDiv: {
        type: String,
        default: 'col-xs-12',
      }
    },

    mounted() {
      const laddaButton = Ladda.create(this.$refs.btnSearch);

      this.$nextTick(() => {
        this.$parent.$parent.$on('loading', (isLoading) => {
          if (isLoading) {
            laddaButton.start();
          } else {
            laddaButton.stop();
          }
        });
      });
    },

    methods: {
      filter() {
        this.$emit('filter-set', this.search);
      },
      filterReset() {
        this.$emit('filter-reset', this.reset);
      },
    },
  };
</script>



// WEBPACK FOOTER //
// node_modules/metawesome-datatable/src/SearchBar.vue